// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const is_dev = false;
const is_local = false;
const localBaseUrl = '/api/' ;
const localBaseUrlWater = 'api/wtms/sjwtms/' ;
const devBaseUrl =  'https://landdev.sujiawuliu.cn:6443/api/' ;
const devBaseUrlWater =  'https://landdev.sujiawuliu.cn:6443/api/wtms/sjwtms/' ;
const productBaseUrl = "https://land.sujiawuliu.cn/api/";
const productBaseUrlWater = "https://land.sujiawuliu.cn/api/wtms/sjwtms/";
// const productBaseUrl = "https://ccl.sujiawuliu.cn/api/";

export const waterIframeUrl = {
  local:'http://localhost:80/#/index',
  dev:'https://landdev.sujiawuliu.cn:6443/wtms/#/index',
  prod:'https://land.sujiawuliu.cn'
}

export const environment = {
  production: true, // 打包之前改为ture
  is_local, 
  is_dev,
  appVersion: '2026.11.04',
  shop_mall_version:'1.0.3',
  tokenKey: "psgToken", // 缓存k ey

   //baseUrl: 'https://landdev.sujiawuliu.cn:8443/api/',
    //  baseUrl: "https://land.sujiawuliu.cn/api/",
         // 扫码打开司机二维码             生产
  
    baseUrl: is_dev ?  (is_local ? localBaseUrl: devBaseUrl) : productBaseUrl,            // 打包之前改为正式domain地址
    baseUrlWater: is_dev ?  (is_local ? localBaseUrlWater: devBaseUrlWater) : productBaseUrlWater,    //水运接口地址
    iframeUrlWater:is_dev ?  (is_local ? waterIframeUrl.local: waterIframeUrl.dev) : waterIframeUrl.prod,//水运项目iframe地址
    // tenantId: is_dev ?   '547815' : '400831' ,//生产
     tenantId: is_dev ?'400831'   :  '547815' ,//dev和测试
    
    qType : is_dev ? 'trial':'release',
  
    
    


  driverQCodeUrl: "https://newcar.51bkx.cn/otms/driver/", // 扫码打开司机二维码              测试
  // driverBulkQCodeUrl: 'https://pfm.51hahy.com/otms/bulkOrder/',      // 扫码打开司机二维码(大宗货源码)   生产
  driverBulkQCodeUrl: "https://newcar.51bkx.cn/otms/bulkOrder/", // 扫码打开司机二维码(大宗货源码)    测试
  // teamQCodeUrl: 'https://pfm.51hahy.com/otms/team/',                 // 扫码打开车主二维码             生产
  teamQCodeUrl: "https://newcar.51bkx.cn/otms/team/", // 扫码打开车主二维码              测试
  // shipperQCodeUrl: 'https://pfm.51hahy.com/otms/shipper/',           // 扫码打开货主二维码             生产
  shipperQCodeUrl: "https://newcar.51bkx.cn/otms/shipper/", // 扫码打开货主二维码              测试
  // qCodeUrl: 'http://weixinislajiyou.natapp4.cc/api',                  // 本地调试域名
  // qCodeUrl: 'https://pfm.51hahy.com/api/',                           // 线上地址域名
  qCodeUrl: "https://newcar.51bkx.cn/api/",
  //qCodeUrl: 'http://rydtest.natapp1.cc/api/',
  downUrl: "https://newcar.51bkx.cn/otms", 
  driverPublishQCodeUrl: "https://newcar.51bkx.cn/otms/publish/", // 扫码打开询价二维码
  // driverPublishQCodeUrl: 'https://pfm.51hahy.com/otms/publish/', // 生产扫码打开询价二维码
  // downUrl:'https://pfm.51hahy.com/otms',
  mode: "prod", // 打包之前改为 prod
};

/* 
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
